module.exports = __webpack_public_path__ + "img/banner2.7172f2dc.jpg";